import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';
import { connectGoogle } from './utils';

export default function* listenGoogleConnect() {
  yield takeEvery(actionTypes.GOOGLE_CONNECT, connectGoogle);
}
